import AbstractService from '@/services/abstractService'

class RegisterRequestsService extends AbstractService {
    endpoint = 'register'

    index() {
      return this.http.get(this.endpoint, { params: { dashboard: true } })
    }
}

const Service = new RegisterRequestsService()

export default Service
